import React, { useEffect } from 'react';
import {
  TabsKeys,
  ValueChainPageProps,
  ButtonProps,
} from 'enums/ValueChainListEnums';
import styles from './ValueChainList.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import DashboardContainer from 'views/Dashboard/DashboardContainer';
import COTabs from 'shared/components/COTabs';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import { getTabs } from './ValueChainHelpers';
import COButton from 'shared/components/COButton';
import { Col, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const ValueChainList: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveTab = (key: string) => {
    let currentPage = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentPage] === key;
  };
  const currentTab = () => {
    let currentUrl = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentUrl];
  };
  const handleTabChange = (key: string) => {
    navigate(`${AppRoutes.VALUE_CHAIN}/${key}`, { replace: true });
  };

  const tabComponents = getTabs({
    isActiveTab,
    handleTabChange,
  });

  useEffect(() => {
    isActiveTab(TabsKeys.PROCESSING_FACILITY);
  }, []);

  const extraContent = currentTab() == TabsKeys.PROCESSING_FACILITY && (
    <Row justify="end" align="middle" className={styles.pfNoteWrapper}>
      <Col className={styles.note} span={12}>
        <Row align="top">
          <Col className={styles.infoIcon}>
            <InfoCircleOutlined />
          </Col>
          <Col span={22}>
            All your Processing Facilities are moved to the Locations under
            Company Setup Page, current page will be removed soon.
          </Col>
        </Row>
      </Col>
      <Col className={styles.createButtonContainer}>
        <COButton disabled>
          <Add /> {ButtonProps.NEW_PROCESSING_FACILITY}
        </COButton>
      </Col>
    </Row>
  );

  return (
    <>
      <DashboardContainer>
        <div className={styles.topContainer}>
          <div className={styles.topLeftContainer}>
            <h1>{ValueChainPageProps.PAGE_TITLE}</h1>
          </div>
          {extraContent}
        </div>
        <div className={styles.secondRowContainer}>
          <div className={styles.tabsContainer}>
            <COTabs components={tabComponents} activeKey={currentTab()} />
          </div>
        </div>
      </DashboardContainer>
    </>
  );
};

export default ValueChainList;
